export const Marquee = ({ items }) => (
  <div className="relative overflow-hidden border-y hairline py-6 md:py-8 bg-[#0d0d0d]" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-serif-display italic text-2xl md:text-4xl font-light text-white/80 px-8 md:px-14 whitespace-nowrap">
            {item}
          </span>
          <span className="text-[#d4af37] text-xl">✦</span>
        </span>
      ))}
    </div>
  </div>
);
